import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import {
  Box,
  IconButton,
  ListItem as ListItemUI,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
  styled,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import setFootprint from '../actions/set-footprint.js';
import {trackEvent} from '../analytics.js';
import formatDate from '../util/format-date.js';
import {Thumbnail} from './list.jsx';

const ListItem = styled(ListItemUI)(({theme}) => ({
  '&:hover': {
    backgroundColor: (theme.vars ?? theme).palette.background.paper,
    backgroundImage:
      'linear-gradient(rgba(255 255 255 / 0.1), rgba(255 255 255 / 0.1))',
    ...theme.applyStyles('light', {
      backgroundColor: 'grey.100',
      backgroundImage: 'none',
    }),
  },
}));

const SceneListItem = ({scene, setFootprint}) => {
  const handleMouseEnter = () => setFootprint(scene.geometry);
  const handleMouseLeave = () => setFootprint(null);
  const handleClickLink = () => {
    const id = `${scene.properties.item_type}::${scene.id}`;
    trackEvent('Redirected to Explorer', {
      sceneId: id,
      link: `https://www.planet.com/explorer/?item=${id}`,
    });
    window.open(`https://www.planet.com/explorer/?item=${id}`, '_blank');
  };

  const acquired = new Date(scene.properties.acquired);

  const secondaryAction = (
    <>
      <Tooltip title="View Scene in Planet Explorer">
        <IconButton onClick={handleClickLink} data-qe="open-in-explorer">
          <OpenInNewOutlinedIcon />
        </IconButton>
      </Tooltip>
    </>
  );
  return (
    <ListItem
      divider
      component="div"
      slotProps={{
        root: {
          'data-qe': 'scene-result',
        },
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      secondaryAction={secondaryAction}
    >
      <ListItemAvatar>
        <Box
          sx={{
            mr: 2,
          }}
        >
          <Thumbnail src={scene._links.thumbnail} />
        </Box>
      </ListItemAvatar>
      <ListItemText disableTypography>
        <Tooltip title="Scene Datetime">
          <Box
            data-qe="scene-datetime"
            sx={{
              display: 'flex',
            }}
          >
            <Typography>{formatDate(acquired)}</Typography>
            <Box
              sx={{
                ml: 1,
              }}
            >
              <Typography variant="caption">
                {acquired.toLocaleTimeString()}
              </Typography>
            </Box>
          </Box>
        </Tooltip>
        <Tooltip title="Scene Id">
          <Typography
            variant="caption"
            data-qe="scene-id"
            sx={{color: 'text.secondary'}}
          >
            {scene.id}
          </Typography>
        </Tooltip>
        {/* TODO: make these more similar to explorer? */}
      </ListItemText>
    </ListItem>
  );
};

SceneListItem.propTypes = {
  setFootprint: PropTypes.func.isRequired,
  scene: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  setFootprint,
};

export default connect(null, mapDispatchToProps)(SceneListItem);
